import { Link } from "react-router-dom";
import { Navbar } from "@/components/layout/Navbar";

/**
 * Email confirmation landing page.
 * Users land here after clicking the confirmation link in their sign-up email.
 * Supabase handles the token exchange automatically via the URL hash.
 *
 * Matches the live site layout: navbar + centered hero with "Thank You!" heading.
 */
export function ConfirmationPage() {
  return (
    <div className="relative isolate flex min-h-screen flex-col">
      <Navbar />
      <main className="flex flex-1 flex-col">
        <section className="overflow-clip" style={{ clipPath: 'polygon(0 -1000%, 100% -1000%, 100% 1000%, 0 1000%)' }}>
          <div className="px-[var(--site-margin)]">
            <div className="mx-auto w-full max-w-[80rem]">
              <div className="py-[6.25rem] max-[991px]:py-[4rem]">
                <div className="relative z-[2] mx-auto flex w-full flex-col items-center text-center">
                  <h1>Thank You!</h1>
                  <div className="w-full pt-6" />
                  <p className="mx-auto w-[min(100%,45ch)] max-w-none">
                    Email confirmed. You can log in now.
                  </p>
                  <div className="w-full pt-6" />
                  <Link
                    to="/app/auth/login"
                    className="inline-flex cursor-pointer items-center justify-center gap-2 rounded-[var(--radius-large)] border-0 bg-[#762a5c] px-8 py-4 text-center text-[clamp(1rem,0.9643rem+0.1786vw,1.125rem)] font-medium leading-none text-white whitespace-nowrap no-underline transition-transform duration-200 ease-[cubic-bezier(0.39,0.575,0.565,1)] hover:-translate-y-[5%] active:scale-95"
                  >
                    Login
                  </Link>
                </div>
              </div>
            </div>
          </div>
        </section>
      </main>
    </div>
  );
}
